export const EXTERNAL_LINKS = {
  TALES_FB: "https://www.facebook.com/TalesComicsAndGames/",
  TALES_IG: "https://www.instagram.com/tales_comicsandgames/",
  TALES_TT: "https://www.tiktok.com/@talesmontagnana",
  TALES_KOFI: "https://ko-fi.com/diregolaarte",
  GREAT_ESCAPE_MONTAGNANA: "https://www.greatescape.it/montagnana/",
  GREAT_ESCAPE: "https://www.greatescape.it/",
  ESCAPE_TALES: "https://www.escapetales.it/",
};
